// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3UY7U","content":"styles_content__2DehQ","selectAll":"styles_selectAll__3cNeW"};